import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {isPlainObject} from '@Utils/object.util';
import type {PlanTableProps, PlanTableStep} from './plan-table.types';
import {PlanTable} from './plan-table';

const isPlanTableStep = (value: unknown): value is PlanTableStep => {
  return isPlainObject(value) && typeof value.number === 'number' && typeof value.task === 'string';
};

export const planTableRegistration = defineStreamComponentRegistration(
  StreamComponentType.PLAN_TABLE,
  PlanTable,
  (props: Record<string, unknown>): PlanTableProps | null => {
    if (!Array.isArray(props.steps) || !props.steps.every(isPlanTableStep)) {
      return null;
    }

    return {steps: props.steps};
  }
);
